export const visit = (vm, at) => {
at({ "en": { "conversations-visitor-ui": { "pageTitleNotifications": { "newMessage": "New Message" } }, "conversationsVisitorUIPageTitleNotifications": { "newMessage": "New Message" } } });
};